module.exports = "/_next/static/images/f18073501ab20136e45b02cf54cd2dc0-digital-account-phone-main-screen@sm-1x.png";